<template>

<!-- <section id="contact"> -->
  <div class="usermanual container">
    <br>

    <p class="font-weight-bold">Table of Content</p>
    <ol>

        <li><CLink href="#" @click="orgRegCollapse = !orgRegCollapse" >Organization Registration</CLink></li>
          <CCollapse :show="orgRegCollapse">
            Email following information to admin@signledger.com:
            <ul>
              <li>
                  Organization name
              </li>
              <li>
                  Contact Person - Name, Address, Email, Phone number
              </li>
              <li>
                  Recipient Emails for - Receiving automated monthly order reports
              </li>
              <li>
                 Google Emails of Admin Users for - Pay.SignLedger.com<br>
                 These are the users who will login and use Order.SignLedger admin functionality.
                 SignLedger relies on Google Accounts for user authentication.<br>
                 If users don't have existing Google account, they can create new one at -<br>
                 <a href="https://accounts.google.com/signup/v2/webcreateaccount?flowName=GlifWebSignIn&flowEntry=SignUp">
                    Create New Google Account
                 </a>
              </li>
            </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="overviewCollapse = !overviewCollapse" >Solution Overview</CLink></li>
          <CCollapse :show="overviewCollapse">
            <ul>
              <li>
                  ‘Employee Checkin’ Application (Checkin.SignLedger.com).<br>
                  Employee location and face picture is captured to verify check-in.
              </li>
              <li>
                  This data enables Time & Attendance reporting.
              </li>
              <li>
                  At the end of salary period, total time worked by employee is calculated.<br>
                  This is then used to calculate salary payable to employees.
              </li>
              <li>
                  Organization can adjust final salary calculation before approving payments.
              </li>
              <li>
                  Bank statements can be generated which can be used for direct salary transfer to employee bank accounts.
              </li>
            </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="dataSetupCollapse = !dataSetupCollapse" >Organization Data Setup by Admins</CLink></li>
          <CCollapse :show="dataSetupCollapse">
              Before 'Pay.SignLedger' can be used, organization admins need to setup following data:
              <ul>
                <li>Departments - Various Departments</li>
                <li>Holidays - Upcoming holidays applicable to various departments</li>
                <li>Users - Profile data and Salary data</li>
                <li>Locations - Various locations from which employees can check in.</li>
                <li>Devices - Various devices from which employees can check in.<br>
                    Each device is associated with Google account/email.</li>
              </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="checkinCollapse = !checkinCollapse" >Employee Check-in</CLink></li>
          <CCollapse :show="checkinCollapse">
            <ul>
              <li>
                  Employees can check-in as many times as required per day. <br>
                  Typically they will check-in once at the time of arrival and once at the time of departure.
              </li>
              <li>
                  Checkin.SignLedger.com - can be accessed from any device<br>(phones-Android/iOS, tablets, laptops)
              </li>
              <li>
                  Organization will have to assign a device user (Google Account) for each check-in device.<br>
                  Login with this user credentials is required before check-in. <br>
                  Multiple employees can check-in on the single device.
              </li>
              <li>
                  Employee will specify their User ID (assigned by Organization), Capture a selfie and click 'Checkin'.<br>
                  Check-in data can be monitored by Organization real time.
              </li>
            </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="timeCollapse = !timeCollapse" >Time & Attendance</CLink></li>
          <CCollapse :show="timeCollapse">
            Check-in data from 'Checkin' application is reported as:
            <ul>
              <li>Report - Details: Every checkin entry for every employee</li>
              <li>Report - Summary: Summary for the given time period</li>
              <li>Report - Daily: One Day Summary</li>
            </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="payCollapse = !payCollapse" >Payroll</CLink></li>
          <CCollapse :show="payCollapse">
            <ul>
              <li>
                  Salary reports will be generated by system on 1st of month.<br>
                  This will include tax calculation. It will calculate employee 'working days' based on 'Checkin' data.
              </li>
              <li>
                  Salary report generation will reference 'Salary' data defined for 'User'.
              </li>
              <li>
                  Organization admins can make changes to salary calculations before approving.
              </li>
              <li>
                  Organization can adjust final salary calculation before approving payments.
              </li>
              <li>
                  Once Salary report is approved, 'User' data for - Advance, Loan, Leaves will be updated.
              </li>
              <li>
                  If employee bank accounts are captured in 'User' data,<br>
                  a bank statement can be generated which can be used for direct salary transfer to employee bank accounts.
              </li>
            </ul>
          </CCollapse>
        <br>

        <li><CLink href="#" @click="gratuityCollapse = !gratuityCollapse" >Gratuity Report</CLink></li>
          <CCollapse :show="gratuityCollapse">
            <ul>
              <li>
                  Organization can generate 'Gratuity Report' anytime. 
              </li>
              <li>
                  This will give snapshot of current 'Gratuity' liability.
              </li>
            </ul>
          </CCollapse>
        <br>

    </ol>




  </div>

  <!-- </section> -->
</template>

<script>
import axios from "axios"

export default {
  name: 'usermanual',
  data () {
    return {
      orgRegCollapse: false,
      overviewCollapse: false,
      dataSetupCollapse: false,
      checkinCollapse: false,
      timeCollapse: false,
      payCollapse: false,
      gratuityCollapse: false,
    }
  },

  methods:{
  },

  components:{
  }
}
</script>


